import { Flex, Group, ScrollArea } from '@mantine/core';
import { SearchCategoryItem } from '../Search/SearchCategoryItem';
import { casinoCategories } from './casino';
export const CasinoCategory: React.FC = () => {
  return <Group justify="center" w="100%" mt={{
    base: 30,
    sm: 34,
    md: 0
  }} style={{
    maskImage: 'linear-gradient(275deg, rgba(255,255,255,0) 0%, rgb(23 26 30) 25%)'
  }}>
      <ScrollArea w="100%" scrollbars="x" type="hover" offsetScrollbars>
        <Flex wrap="nowrap" gap={{
        base: 10,
        sm: 14
      }} justify="space-between">
          {casinoCategories.map(item => <SearchCategoryItem key={item.text} {...item} />)}
        </Flex>
      </ScrollArea>
    </Group>;
};